export const POSTING_GOAL_OPTIONS = [
  {
    title: 'Keep it steady · 1 time/week',
    description: 'Stay visible effortlessly (and grow your posting streak 🪴)',
    goal: 1,
    color: 'purple',
  },
  {
    title: 'Build a presence · 3 times/week',
    description: 'Stay top-of-mind and spark conversations.',
    goal: 3,
    color: 'orange',
  },
  {
    title: 'Reach new heights · 5 times/week',
    description: 'Maximize visibility and reach.',
    goal: 5,
    color: 'teal',
  },
]

export const DEFAULT_POSTING_GOAL = POSTING_GOAL_OPTIONS[1]
